import React from "react";
import "../CSS/styles.css";
import Story1 from '../../assets/stoty.png';

const Story = () => {
  return (
    <div className="container mt-5 inter">
      <div className="row align-items-center">
        <div className="col-lg-6 col-12 px-lg-0 px-4 mb-lg-0 mb-4">
          <h1 className="fw-bold mb-0 bc">Our Story</h1>
          <p className="mb-0 mt-5 gc2">TAMBRO (Pvt.) Ltd. was founded with a vision to provide comprehensive security and risk management solutions to organizations worldwide. With decades of combined   experience, our team of experts has worked across various sectors and regions to deliver tailored solutions that address complex challenges.</p>
          <p className="mb-0 gc2 mt-3">Today, we are a global provider of Risk Management, Crisis Management, Project Support, Research & Analysis, GIS, Cyber Security, Training & Capacity Building, and Digital Solutions. Our commitment to excellence and innovation has made us a trusted partner for organizations seeking to navigate an increasingly complex risk landscape. </p>
        </div>
        <div className="col-lg-6 col-12">
          <img src={Story1} alt="" className="img-fluid int2 w-100" width="100%" />
        </div>
      </div>
    </div>
  )
}

export default Story